
import Header from './components/Header';
import TvBootIntro from './components/TvBootIntro';
import TVEffect from './components/TVEffect';
import NewsletterForm from './components/NewsletterForm';
import SuccessModal from './components/SuccessModal';
import EventGallery from './components/EventGallery';
import Destaques from './components/Destaques';
import NotFound from './components/NotFound';


import { HookNewsletterForm } from './hooks/HookNewsletterForm';
import { HookNavbar } from './hooks/HookNavbar';



import { useState } from 'react';
import { Routes, Route } from 'react-router-dom';


import './App.css';
function App() {
  const navbar = HookNavbar();

  const {
    showForm,
    setShowForm,

    preferredContact,
    email,
    phone,
    cpf,
    fullName,
    birthDate,
    cityState,
    instagram,
    nationality,
    attendedEvent,
    setAttendedEvent,

    onPreferredContactChange,
    onEmailChange,
    onPhoneChange,
    onCpfChange,
    onFullNameChange,
    onBirthDateChange,
    onCityStateChange,
    onCitySuggestionSelect,
    onInstagramChange,
    onNationalityChange,

    citySuggestions,

    isSubmitting,
    submitError,
    setSubmitError,

    onSubmit,
  } = HookNewsletterForm();

  const [successModal, setSuccessModal] = useState({ show: false, isNew: true });

  return (
    <>
      <TvBootIntro />
      <div
        className="crt-noise"
        aria-hidden="true"
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/files/images/crt-noise.png)` }}
      />

      <Header {...navbar} />

      {/* Fora das Routes de propósito: o form e o modal de sucesso agora
          abrem por cima de qualquer rota (Destaques, 404, home), não só
          da "/". O estado continua todo em App — só o JSX subiu. */}
      {showForm && (
        <NewsletterForm
          setShowForm={setShowForm}
          setSuccessModal={setSuccessModal}
          onSubmit={onSubmit}
          preferredContact={preferredContact}
          email={email}
          phone={phone}
          cpf={cpf}
          fullName={fullName}
          birthDate={birthDate}
          cityState={cityState}
          onPreferredContactChange={onPreferredContactChange}
          onEmailChange={onEmailChange}
          onPhoneChange={onPhoneChange}
          onCpfChange={onCpfChange}
          onFullNameChange={onFullNameChange}
          onBirthDateChange={onBirthDateChange}
          onCityStateChange={onCityStateChange}
          onCitySuggestionSelect={onCitySuggestionSelect}
          instagram={instagram}
          onInstagramChange={onInstagramChange}
          nationality={nationality}
          onNationalityChange={onNationalityChange}
          attendedEvent={attendedEvent}
          setAttendedEvent={setAttendedEvent}
          citySuggestions={citySuggestions}
          isSubmitting={isSubmitting}
          submitError={submitError}
          setSubmitError={setSubmitError}
        />
      )}

      {successModal.show && (
        <SuccessModal
          isNew={successModal.isNew}
          onClose={() => setSuccessModal({ show: false, isNew: true })}
        />
      )}

      <Routes>
        {/* /showcase serve os Destaques. A PartnersPage antiga (vitrine de
            parceiros) foi apagada na migration 005, junto com o carrossel
            `featured` e a tabela partner_items que ela consumia. */}
        <Route path="/showcase" element={<Destaques setShowForm={setShowForm} />} />
        <Route path="/events" element={<EventGallery />} />
        <Route path="*" element={<NotFound setShowForm={setShowForm} />} />
        <Route
          path="/"
          element={<TVEffect setShowForm={setShowForm} />}
        />
      </Routes>

</>
  );
}

export default App;
